export default function redirectToWhatsApp(phoneNumber: string, text: string) {
    // const textHtml = encodeURIComponent(text);
    // const url = 'https://web.whatsapp.com/send?phone=' + phoneNumber + '&text=' + textHtml;
    const url = 'https://wa.me/' + phoneNumber + '/?lang=id&text=' + text;
    window.open(url, '_blank');
}
